interface DotGridProps {
  cols?: number;
  rows?: number;
  gap?: number;
  dotSize?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  className?: string;
}

const COLOR_MAP: Record<string, string> = {
  primary: 'var(--color-primary-500)',
  secondary: 'var(--color-secondary-500)',
  accent: '#10B981',
  neutral: '#64748b',
};

export function DotGrid({
  cols = 8,
  rows = 8,
  gap = 18,
  dotSize = 3,
  color = 'primary',
  opacity = 0.35,
  className = '',
}: DotGridProps) {
  const width = (cols - 1) * gap + dotSize * 2;
  const height = (rows - 1) * gap + dotSize * 2;

  const dots: { cx: number; cy: number }[] = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      dots.push({ cx: dotSize + c * gap, cy: dotSize + r * gap });
    }
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      className={className}
      style={{ opacity }}
    >
      {dots.map((d, i) => (
        <circle key={i} cx={d.cx} cy={d.cy} r={dotSize} fill={COLOR_MAP[color]} />
      ))}
    </svg>
  );
}
